export default __webpack_public_path__ + "6844a17f2039000a840fa36290b90fdb.ttf";